import { Society } from 'types';

export const getSocietyTotalShares = (society: Society) => {
  if (!society || !society?.sharesCount) return 0;

  const { actual, future, drafts } = society?.sharesCount || {
    actual: 0,
    future: 0,
    drafts: 0,
  };

  return (actual || 0) + (future || 0) + (drafts || 0);
};
